module.exports = __webpack_public_path__ + "static/pie2-c5ead986a3fcbabb8ba8ec658eedb280.png";